module.exports = __webpack_public_path__ + "static/media/dreidel.1c2ec600.svg";